import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { Utils } from "ng/src/app/core/utils";

angular.module('logbook').directive('fileAttachments', ['FileUploader', 'imageViewerService', '$location',
	function(FileUploader, imageViewerService, $location) {
  return {
    redirect: 'E',

    scope: {
      files: '=',
	  noteId: '<?',
      isUploading: '=',
      log: '=',
      removeFiles: '=',
      newFiles: '=',
      removeFileObjects: '=',
      hideDropzone: '=',
      inputTabIndex: '=',
      onChange: '&'
    },

	template: require('./file-attachments.html'),

    link: function(scope, elem, attrs) {

       scope.uploadErrors = [];
       
       scope.uploader = new FileUploader({
          url: '/api/files/',
          autoUpload: true,
          removeAfterUpload: true,
          onSuccessItem: function(item, response, status, headers) {
             scope.files.push(response);
             scope.newFiles.push(response.id);
             scope.onChange && scope.onChange();
          },
          onErrorItem: function(item, response, status, headers) {
             var msg = '';
             if(item && item.file && item.file.name)
                msg += 'Error uploading ' + item.file.name + ': ';
             if( response && response.message )
                msg += response.message;
             scope.uploadErrors.push(msg);
          },
          onAfterAddingAll: function(addedItems) {
             scope.uploadErrors.length = 0;
          }
        });
       
       scope.uploader.headers['Accept'] = 'application/json';
       
       scope.uploader.onBeforeUploadItem = function(item) {
          item.formData.length = 0;
          item.formData.push({
             logId: scope.log.id
          });
       }
       
       scope.removeFile = function(file)
       {
          scope.removeFiles.push(file.id);
          scope.removeFileObjects && scope.removeFileObjects.push(file); 
          scope.onChange && scope.onChange();
       };
       
       scope.isFileRemoved = function(file)
       {
          return scope.removeFiles && scope.removeFiles.indexOf(file.id) >= 0;
       };
       
       scope.unRemoveFile = function(file)
       {
          scope.removeFiles.splice(
             scope.removeFiles.indexOf(
                file.id), 1);
          scope.removeFileObjects && scope.removeFileObjects.splice(
                scope.removeFileObjects.indexOf(file), 1);
          scope.onChange && scope.onChange();
       };

       scope.$watch('uploader.isUploading', function(val) {
          scope.isUploading = scope.uploader.isUploading;
       });
       
		scope.viewImage = function(file) {
			const noteId = scope.noteId || ($location.search().note && $location.search().note.match(/\d+$/)[0]);

		   	if (noteId)
			   	imageViewerService.showImageFromId(file.id, noteId);
			else
				imageViewerService.showImageViewer(`/api/files/${file.id}`, scope.files);
        };

       scope.isImage = function(file) {
			 return FileAttachment.isImage(file);
		};
		
		scope.getAttachmentText = (file) => {
			const updated = new Date(file.updated),
				fileSize = FileAttachment.humanReadableFileSize(file.fileSize);
			
			let dateString = Utils.isToday(updated) ? 'today,' :
				updated.toLocaleDateString('en-US', {
					month: 'numeric',
					day: 'numeric',
					...!Utils.isCurrentYear(updated) && { year: 'numeric' },
					hour12: false,
					hour: 'numeric',
					minute: 'numeric'
				});


			return `${fileSize}\n${dateString} ${file.updatedBy.firstName} ${file.updatedBy.lastName}`;
		};
    }
  };
}]);
